import React, { Component } from 'react';
import { _, map } from 'lodash';
import {
    getPendingPayouts as fetchPendingPayouts,
    fetchUrl,
    deletePendingPayouts
} from './pendingPayoutsActions';
import {
    getPendingPayouts,
    getCount,
    getPages,
    getPendingPayoutsErrorMessage,
    getIsPendingPayoutsLoading,
    getWasDeletePendingPayoutsSuccessful,
    getIsDeletePendingPayoutsLoading
} from '../PendingPayouts/pendingPayoutsEntity';
import PayoutListItem from '../Payouts/PayoutListItem/PayoutListItem';

import Table from '../Table/Table';
import { dataTransform } from '@nexio/emvio-util-app';
import PropTypes from 'prop-types';

import { getSelectedPayoutAccountIdsString } from '../PayoutAccountSelector/payoutAccountSelectorViewState';
import { getPayoutAccountsMapper } from '../PayoutAccounts/payoutAccountEntity';
import { getColumnsByUniqueTableName } from '../Table/tableEntity';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { getCustomAccess } from '../Self/selfEntity';
import { toggleModal } from '../Modal/modalActions';
import { getIsUserAnAdmin } from '../UserData/userDataEntity';

import { toastIfError } from '../../utils/toast';
import { toast } from 'react-toastify';
import {
    doesPropExistAndHasItChanged
} from '@nexio/emvio-util-app';
import CurrencyCodeFilter from '../Table/Filters/CurrencyCodeFilter/CurrencyCodeFilter';
import ColorDollarAmountCell from '../Table/Cells/ColorDollarAmountCell/ColorDollarAmountCell';
import './PendingPayouts.scss';

export class PendingPayouts extends Component {
    static propTypes = {
        selectedPayoutAccountIds: PropTypes.string,
        match: PropTypes.shape({
            isExact: PropTypes.bool,
            params: PropTypes.shape({
                currency: PropTypes.string,
                batchRef: PropTypes.string,
                providerId: PropTypes.string
            }),
            path: PropTypes.string,
            url: PropTypes.string
        }),
        onToggleModal: PropTypes.func.isRequired,
        columns: PropTypes.array,
        payoutAccountMap: PropTypes.any,
        timezone: PropTypes.string,
        customAccess: PropTypes.any,
        isAdmin: PropTypes.bool,
        PendingPayoutsErrorMessage: PropTypes.string,
        isPendingPayoutsLoading: PropTypes.bool,
        isDeletePendingPayoutsLoading: PropTypes.bool,
        wasDeletePendingPayoutsSuccessful: PropTypes.bool

    };

    constructor(props) {
        super(props);

        this.state = { needsRefetch: false };
        this.defaultColumnsAndProps = [
            {
                accessor: 'firstName',
                className: ['cursor-pointer'],
                label: 'First Name',
                minWidth: 120,
                show: true,
                sortable: false
            },
            {
                accessor: 'lastName',
                className: ['cursor-pointer'],
                label: 'Last Name',
                minWidth: 120,
                show: true
            },
            {

                accessor: 'amount',
                Cell: (props) => <ColorDollarAmountCell amount={props.value} currencyCode={props.original.currency} />,
                className: ['cursor-pointer'],
                label: 'Amount',
                minWidth: 90,
                show: true
            },
            {
                accessor: 'email',
                className: ['cursor-pointer'],
                label: 'Email',
                minWidth: 175,
                show: true
            },
            {
                accessor: 'currency',
                transformData: dataTransform.uppercase,
                Filter: ({ filter, onChange }) => (<CurrencyCodeFilter
                    filter={filter}
                    onChange={onChange}
                    allowAllCurrencies
                    shouldUseCurrencyCodeAsValue />
                ),
                className: ['cursor-pointer'],
                label: 'Currency',
                minWidth: 75,
                show: true,
                sortable: false,
                filterable: false
            },
            {
                accessor: 'country',
                className: ['cursor-pointer'],
                label: 'Country',
                minWidth: 85,
                show: true,
                sortable: true,
                filterable: true
            },
            {
                accessor: 'providerId',
                className: ['cursor-pointer'],
                label: 'Provider ID',
                minWidth: 85,
                show: true,
                sortable: false,
                filterable: false
            },
            {
                accessor: 'batchRef',
                className: ['cursor-pointer'],
                label: 'Batch Ref',
                minWidth: 250,
                show: true,
                sortable: false,
                filterable: false
            }
        ];
    }

    componentDidUpdate(prevProps) {
        toastIfError(prevProps, this.props, 'PendingPayoutsErrorMessage');

        if (doesPropExistAndHasItChanged(prevProps, this.props, 'wasDeletePendingPayoutsSuccessful') && (this.props.wasDeletePendingPayoutsSuccessful)) {
            toast('Delete Pending Payout was Successful!', { type: 'success' });
            this.refetchData();
        }
    }

    refetchData = () => {
        this.setState({ needsRefetch: true });
    };

    resetNeedsRefetch = () => {
        this.setState({ needsRefetch: false });
    };

    getPayoutAccountsDropDown = () => {
        const result = {};
        _.forEach(this.props.payoutAccountMap, (value, key) => {
            result[key] = `${key} - ${value}`;
        });

        return result;
    };

    pendingDelete = (pendingPayouts) => {
        const pendingPayoutIds = map(pendingPayouts, 'id');

        return (deletePendingPayouts({ pendingPayoutIds }));
    };

    render() {
        const bulkActions = [{
            ButtonLabel: 'Reject Selected',
            confirmationText: 'This deletes the selected payouts and cannot be undone. If you accidentally reject a payout, you would need to re-run the batch and generate a new report.',
            loading: this.props.isPendingPayoutsLoading || this.props.isDeletePendingPayoutsLoading,
            onClick: this.pendingDelete
        }];

        return (
            <div className="emvio-pending-payouts">
                <Table
                    bulkActions={bulkActions}
                    shouldAddCheckboxColumn
                    fetchUrl={fetchUrl}
                    className="emvio-pending-payouts-table"
                    defaultColumnsAndProps={this.defaultColumnsAndProps}
                    defaultSorted={[{
                        desc: true,
                        id: 'id'
                    }]}
                    fetchData={(filters, page, pageSize, sorters, merchantIds, columns, batchRef) => {
                        filters = [...filters, {
                            id: 'providerId',
                            value: this.props.match.params.providerId
                        },
                        { id: 'currency', value: this.props.match.params.currency },
                        { id: 'batchRef', value: this.props.match.params.batchRef }
                        ];

                        return fetchPendingPayouts(filters, page, pageSize, sorters, this.props.selectedPayoutAccountIds, columns, batchRef);
                    }}
                    shouldHideExport
                    countSelector={getCount}
                    dataSelector={getPendingPayouts}
                    errorMessageSelector={getPendingPayoutsErrorMessage}
                    isDataLoadingSelector={getIsPendingPayoutsLoading}
                    pagesSelector={getPages}
                    itemKey="id"
                    ListItemComponent={PayoutListItem}
                    noDataText="No Pending Payouts"
                    uniqueTableName="pendingPayouts"
                    resetNeedsRefetch={this.resetNeedsRefetch}
                    needsRefetch={this.state.needsRefetch}
                    filterable={true}
                    data={this.state.data}
                />
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        selectedPayoutAccountIds: getSelectedPayoutAccountIdsString(state),
        columns: getColumnsByUniqueTableName(state, 'Payouts'),
        payoutAccountMap: getPayoutAccountsMapper(state),
        customAccess: getCustomAccess(state),
        isAdmin: getIsUserAnAdmin(state),
        isPendingPayoutsLoading: getIsPendingPayoutsLoading(state),
        isDeletePendingPayoutsLoading: getIsDeletePendingPayoutsLoading(state),
        wasDeletePendingPayoutsSuccessful: getWasDeletePendingPayoutsSuccessful(state),
        PendingPayoutsErrorMessage: getPendingPayoutsErrorMessage(state)
    };
}

function mapDispatchToProps(dispatch) {
    return { onToggleModal: () => dispatch(toggleModal('uploadPayouts')) };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PendingPayouts));
